import React, { createContext, useCallback, useContext, useMemo, useReducer, useState } from 'react'
import useOperatorStorage from '../../hooks/localStorage/useOperatorStorage';

export const OperatorContext = createContext();

const OperatorFlag = {
  Offline:      'Operator-Offline',
  Logout:       'Operator-Logout',
  Eject:        'Operator-Eject',
  Ready:        'Operator-Ready',
  Error:        'Operator-Error',
  FooterMsg:    'Operator-FooterMsg'
}

export default function OperatorContextProvider({children}) {
  const [landed, setLanded] = useState(false);
  const {operator, setOperator} = useOperatorStorage();

  const operatorReducer = (state, action) => {
    const cmd = action.type;
    if (state.flag === cmd) {      
      return state;
    }

    const msg = action.payload?.msg;
    const params = action.payload?.params;    
    const next = {...state, flag: cmd, msg: msg, params: params};
    // console.debug('[OperatorContextProvider REDUCER] %s ---> %s', state.flag, next.flag);
    return next;
  }

  const [state, dispatch] = useReducer(operatorReducer, { flag: OperatorFlag.Offline });

  const dispatchOperatorFlag = useCallback((operatorFlag, msg, args) => {
    dispatch({type: operatorFlag, message: msg, params:args});
  }, [dispatch]);

  const dispatchOperatorFooterMsg = useCallback(() => {
    dispatchOperatorFlag(OperatorFlag.FooterMsg);
  }, [dispatchOperatorFlag]);

  const isOperatorFlag = useCallback((operatorFlag) => {
    return state.flag === operatorFlag;
  }, [state.flag]);

  const isOperatorReady = useCallback(() => {
    return isOperatorFlag(OperatorFlag.Ready);
  }, [isOperatorFlag]);

  const isOperatorEject = useCallback(() => {
    return isOperatorFlag(OperatorFlag.Eject);
  }, [isOperatorFlag]);

  const memoizedValue = useMemo(()=>({
    operator, setOperator,
    operatorState:state,
    dispatchOperatorFlag,
    dispatchOperatorFooterMsg,
    isOperatorFlag,
    isOperatorReady,
    isOperatorEject,
    OperatorFlag,
    landed, 
    setLanded
  }), [operator, setOperator,
    state,
    dispatchOperatorFlag,
    dispatchOperatorFooterMsg,
    isOperatorFlag,
    isOperatorReady,
    isOperatorEject,
    landed, 
    setLanded
]);

  return (
    <OperatorContext.Provider value={memoizedValue}>{children}</OperatorContext.Provider>
  )
}

export function useOperatorContext() {
  return useContext(OperatorContext);
}